import { Box } from '@mui/material';
import styled from 'styled-components';

export const UnumDetailTextStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
});

export const UnumDetailFieldStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const UnumDetailInputStyled = styled(Box)({
  marginTop: '-32px',
});
